import { ApiMail, LocalAPI } from './api';
import { PAYMENT_PATHS } from './checkoutPaymentPaths';

export function sendEmail(content) {

    return new Promise(function (resolve, reject) {
        ApiMail
            .post(`/sendemail`, content)
            .then(res => {
                if (res.data === '') {
                    reject(undefined);
                } else {
                    resolve(res.data);
                }
            })
            .catch(err => {
                console.log(err);
                reject(undefined);
            });
    });
};

export function setAceiteTermos(numOrder, numDoc, IP) {

    return new Promise(function (resolve, reject) {
        ApiMail
            .post(`/termos`, { "numOrder": numOrder, "numDoc": numDoc, "IP": IP })
            .then(res => {
                if (res.data === '') {
                    reject(undefined);
                } else {
                    //console.log(res.data);
                    resolve(res.data);
                }
            })
            .catch(err => {
                console.log(err);
                reject(undefined);
            });
    });
};

export function getPixInfo(order, description, amount,use_2nd_bank=false,use_static=false,isUsdtPixPayment=false) {

    return new Promise(function (resolve, reject) {
        ApiMail
            .post(PAYMENT_PATHS.pix, { "order": order, "description": description, "amount": amount,use_2nd_bank,use_static,is_usdt_pix:isUsdtPixPayment })
            .then(res => {
                if (res.data === '') {
                    reject(undefined);
                } else {                   
                    resolve(res.data);
                }
            })
            .catch(err => {
                console.log(err);
                reject(undefined);
            });
    });
};

export function getAceiteTermos(numOrder) {
    //console.log("order - " + numOrder);
    return new Promise(function (resolve, reject) {
        ApiMail
            .get(`/termos`, 
            { 
                headers: { "numOrder": numOrder } 
            })
            .then(res => {
                if (res.data === '') {
                    reject(undefined);
                } else {
                    //console.log(res.data);
                    resolve(res.data);
                }
            })
            .catch(err => {
                if(err.response){
                    if(err.response.data){
                        reject(err.response.data);
                    }else{
                        reject(err.response);
                    }
                }else{
                    reject(err);
                }
            });
    });
};

export function getWithdrawl(order) {

    return new Promise(function (resolve, reject) {
        ApiMail
            .post(`/withdrawl`, { "numOrder": order })
            .then(res => {
                if (res.data === '') {
                    resolve(undefined);
                } else {
                    resolve(res.data);
                }
            })
            .catch(err => {
                console.log(err);
                resolve(undefined);
            });
    });
};

export function getDeposit(order) {

    return new Promise(function (resolve, reject) {
        ApiMail
            .post(`/deposit`, { "numOrder": order })
            .then(res => {
                if (res.data === '') {
                    resolve(undefined);
                } else {
                    resolve(res.data);
                }
            })
            .catch(err => {
                console.log(err);
                alert(err.toString());
                resolve(undefined);
            });
    });
};

export function requestBilletPF(cpf, amount, name, phone, order, data, email) {

    return new Promise(function (resolve, reject) {
        //reject({err: ""});
        ApiMail
            .post(PAYMENT_PATHS.boleto, {
                "cgccpf": cpf,
                "amount": amount,
                "name": name,
                "phone": phone,
                "order": order,
                "data": data,
                "paramName" : "PF", 
                "email":email
            })
            .then(res => {
                //console.log(res.data);
                resolve(res.data);
            })
            .catch(err => {
                if (err.response !== undefined) {
                    console.log(err.response.data);
                    reject(err.response.data);
                } else {
                    console.log(err);
                    reject(err);
                }
            });
    });
};

export function requestBilletPJ(cnpj, amount, companyName, phone, order, data, email) {

    return new Promise(function (resolve, reject) {
        //reject({err: ""});
        ApiMail
            .post(PAYMENT_PATHS.boleto, {
                "cgccpf": cnpj,
                "amount": amount,
                "name": companyName,
                "phone": phone,
                "order": order,
                "data": data,
                "paramName" : "PJ", 
                "email":email
            })
            .then(res => {
                //console.log(res.data);
                resolve(res.data);
            })
            .catch(err => {
                if (err.response !== undefined) {
                    console.log(err.response.data);
                    reject(err.response.data);
                } else {
                    console.log(err);
                    reject(err);
                }
            });
    });
};

export function getPSE(amount,order_no) {
   
    return new Promise(function (resolve, reject) {       
        ApiMail
            .post(PAYMENT_PATHS.pse, {
                "amount" : amount,
                "order" : order_no, 
                "description" : order_no
            })

            .then(res => {                          
               resolve(res.data);               
            })
            .catch(err => {
                if (err.response !== undefined) {
                    console.log(err.response.data);
                    reject(err.response.data);
                } else {
                    console.log(err);
                    reject(err);
                }
            });

   
    });
};

export function getEfecty(amount, order_no, nomeClient, documentClient, email) {
   
    return new Promise(function (resolve, reject) {  
             
        ApiMail
            .post(PAYMENT_PATHS.efecty, {
                "amount" : amount,
                "order" : order_no, 
                "description" : order_no,
                "name" : nomeClient,
                "email" : email,
                "document" : documentClient
            })

            .then(res => {                          
               resolve(res.data); 
                          
            })
            .catch(err => {
                if (err.response !== undefined) {
                    console.log(err);
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function getWallet(amount, order_no, nomeClient, documentClient, email) {
   
    return new Promise(function (resolve, reject) {       
        ApiMail
            .post(PAYMENT_PATHS.wallet, {
                "amount" : amount,
                "order" : order_no, 
                "description" : order_no,
                "name" : nomeClient,
                "email" : email,
                "document" : documentClient
            })

            .then(res => {                                        
               resolve(res.data);
                            
            })
            .catch(err => {
                if (err.response !== undefined) {
                    console.log(err);
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};


export function getAvailableCrypto(provider) {
   
    let url='/available_coin';
    if(provider==="crypto_now"){
        url='/nowpayment_available_coin'
    }else if(provider==="cryptopayx"){
        url='/cryptopayx_available_coin'
    }

    return new Promise(function (resolve, reject) {       
        ApiMail
            .get(url)
            .then(res => {                                        
               resolve(res.data);
                            
            })
            .catch(err => {
                if (err.response !== undefined) {
                    console.log(err);
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};



export function getCrypto(order_no, currency,is_usdt_pix=false,provider) {

    let url = PAYMENT_PATHS.crypto;
    if (provider === "crypto_now") {
        url = PAYMENT_PATHS.nowpayment_deposit
    }else if(provider === "cryptopayx"){
        url = '/cryptopayx_deposit'
    }

    return new Promise(function (resolve, reject) {  
             
        ApiMail
            .post(url, {
                "order_no" : order_no, 
                "currency" : currency,
                "is_usdt_pix":is_usdt_pix
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    console.log(err);
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function getLpBankList(country) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .get(`/lp_bank_list?country=${country}`)
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    console.log(err);
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};
export function getLPMasterAccount(order_no,data) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/lp_master_account`,{
                order_no,...data
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function postLpCC(order_no,cardtype,data) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/lp_card`,{
                order_no,cardtype,...data
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function getLPCashInfo(order_no,data) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/lp_cash`,{
                order_no,...data
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};


export function stripePaymentIntent(order_no,walletName="google-pay") {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/stripe-payment-intent`,{
                order_no,walletName
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function getGpayData(order_no) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/gpay_data`,{
                order_no
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function getNewAmount(order_no,payment_method,instalment=0) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/new_amount`,{
                order_no ,payment_method,instalment
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function callPicPayApi(order_no) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(PAYMENT_PATHS.picpay,{
                order_no    
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function postStripeCC(order_no,data) {
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/stripe_card`,{
                order_no,...data
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};


export function postPrimefyCC(order_no,data) {
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/primefy_card`,{
                order_no,...data
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};


export function postBigoPayCC(order_no,data) {
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/bigopay_card`,{
                order_no,...data
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function getCCBStatus(txn_no) {
    return new Promise(function (resolve, reject) {  
        ApiMail
            .get(`/bigopay_trn/${txn_no}`)
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function postCCX(order_no,data) {
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/xorapay_card`,{
                order_no,...data,remoteIp:sessionStorage.getItem("ipNumber")
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function postRasPayCC(order_no,data) {
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/raspay_card`,{
                order_no,...data
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function postAsaasCC(order_no,data) {
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/asaas_card`,{
                order_no,...data,remoteIp:sessionStorage.getItem("ipNumber")
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};
export function callPayCashApi(order_no) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(PAYMENT_PATHS.paycash,{
                order_no    
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function callMonnetApi(order_no,payment_type,cbu=null) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(PAYMENT_PATHS.monnet_payment,{
                order_no,
                payment_type,
                cbu
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function callCobreApi(order_no) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(PAYMENT_PATHS.cobre_payment,{
                order_no
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function callProntoPagaApi(order_no,payment_type,phoneNumber) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(PAYMENT_PATHS.prontopaga_payment,{
                order_no,
                payment_method:payment_type,
                phoneNumber
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function callMorePaymentApi(order_no,payment_type) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/morepayment`,{
                order_no,
                payment_method:payment_type
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function callMids88Api(order_no,payment_type) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(PAYMENT_PATHS.mids88,{
                order_no,
                payment_method:payment_type
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function callRixsusApi(order_no,payment_type) {

    return new Promise(function (resolve, reject) {
        ApiMail
            .post(`/rixsus`,{
                order_no,
                payment_method:payment_type
            })
            .then(res => {
               resolve(res.data);
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });
    });
};

export function callSauriPayApi(order_no,payment_type,phone_number) {

    return new Promise(function (resolve, reject) {
        ApiMail
            .post(`/sauripay_deposit`,{
                order_no,
                payment_method:payment_type,
                phone_number
            })
            .then(res => {
               resolve(res.data);
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });
    });
};

export function callPayokApi(order_no, payment_method_code, additionalData = {}) {
    return new Promise(function (resolve, reject) {
        ApiMail
            .post(PAYMENT_PATHS.payok_payment, {
                order_no,
                payment_method_code,
                ...additionalData
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });
    });
};

export function callOfaPayApi(order_no,payment_type,accountName,bankNo) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(PAYMENT_PATHS.ofapay,{
                order_no,
                payment_method:payment_type,
                accountName,bankNo
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function callGACCApi(order_no, addressData = {}) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/xorapay`,{
                order_no,
                remoteIp:sessionStorage.getItem("ipNumber"),
                ...addressData
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};


export function callBitsoClabe(order_no) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/bitso_clabe`,{
                order_no    
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function updateDepositWallet(order_no,deposit_wallet) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/deposit_wallet`,{
                order_no,deposit_wallet    
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};


export function callPaykuPaymentApi(order_no,payment_type) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/payku_payment`,{
                order_no,
                payment_method:payment_type
            })
            .then(res => {                          
               resolve(res.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};


export function callStarpagoApi(order_no,payment_type) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(PAYMENT_PATHS.starpago_payment,{
                order_no,
                payment_method:payment_type
            })
            .then(res => {                          
               resolve(res.data.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};

export function callSimplypayApi(order_no) {
   
    return new Promise(function (resolve, reject) {  
        ApiMail
            .post(`/simplypay`,{
                order_no
            })
            .then(res => {                          
               resolve(res.data.data); 
            })
            .catch(err => {
                if (err.response !== undefined) {
                    reject(err);
                } else {
                    console.log(err);
                    reject(err);
                }
            });   
    });
};
